import React from 'react'
import './Join.css'

export const Join = () => {
  return (
        <div className="join" id='join'>
            <div className="left-j">
                <hr/>
                <div>
                <span className='stroke-text'>ready to</span>
                <span >level up</span>
                </div>
                <div>
                <span>your body</span>
                <span className='stroke-text'>with us?</span>
                </div>
            </div>
            <div className="right-j">
                <form action="" className='email-container' id='email-container'>
                    <input type="email"  placeholder='Enter you email address '/>
                    <button className='btn btn-j'>Join Now</button>
                </form>
            </div>
        </div>
  )
}
